import React from "react";
import { Chip, Typography, CircularProgress } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useDispatch } from "react-redux";
import {
  handleAppSelectedTopic,
  handleAppSelectedTopicToSaveMsg,
  handleScrollToBottom,
  handleStarMsgScreen,
} from "../../../appStore/actions/AppState/action";
import { handleFetchMessages } from "../../../appStore/actions/ArkchatGroup/action";
import useAppSelectors from "../../../customHooks/useAppSelectors"
import { ChatSearchButton, SmallIcon } from "../../../common/chatComponents/ScreenSearchSection";
import searchIcon from "../../../assets/images/chats/searchIcon.svg";
import blackCrossIcon from "../../../assets/images/chats/blackCrossIcon.svg"
import { colorSchemes, fontSizeSchemes } from "../../../assets/commonFunction";
import closeIconBlack from "../../../assets/images/chats/closeLogoBlack.svg";
import { useTranslation } from "react-i18next";

const SearchInputFromGroupInfo = ({ 
  setMediaFilesOpen,
  handleBacktoMessage,
  handleSearch,
  searchInputValue,
  handleSearchInputChange,
  type,
  isSearching = false ,
  filteredMessageList
}) => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const appContent = t("AppContent", {
    returnObjects: true,
  });
  const { selectedGroup, selectedTopic, showStarMessage } =
    useAppSelectors();
  const handleDelete = () => {
    dispatch(handleAppSelectedTopic(null));
    dispatch(handleAppSelectedTopicToSaveMsg(null));
    dispatch(handleFetchMessages(selectedGroup?.pnId, null));
  };
  const handleRemoveStarScreen = () => {
    dispatch(handleStarMsgScreen(!showStarMessage));
    dispatch(handleFetchMessages(selectedGroup?.pnId, selectedTopic?.id));
    dispatch(handleScrollToBottom(true));
  };

  const handleClearSearch = () => {
    if (searchInputValue) {
      handleSearchInputChange("", type);
    } else {
      handleSearch(type);
    }
  };

  return (
    <Box display={"flex"} flexDirection={"column"} gap={"0.1rem"} width={'100%'}>
    <Stack
      width="100%"
      direction="row"
      justifyContent="center"
      alignItems="center"
      paddingLeft={type === "main" ? 4.2 : 5.3}
      paddingRight={9}
      sx={{
        height: "2.5rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          background: "#fff",
          border: "1px solid #BDBDBD",
          borderRadius: "4px",
          px: 1,
          height: "2rem",
        }}
      >
        <input
          value={searchInputValue}
          type="text"
          onChange={(e) => (
            handleSearchInputChange && handleSearchInputChange(e.target.value,type)
          )}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && searchInputValue) {
              handleSearchInputChange("", type);
            } else if (e.key === 'Escape') {
              handleSearch(type);
            }
          }}
          placeholder="Search chats and files"
          style={{
            border: "none",
            outline: "none",
            flex: 1,
            background: "transparent",
            fontSize: fontSizeSchemes.font14,
            fontWeight: 400,
            padding: "0 8px",
          }}
        />
        {isSearching && (
          <CircularProgress
            size={16}
            sx={{
              color: colorSchemes.themeRedColor,
              marginRight: 1,
            }}
          />
        )}
        <img
          src={closeIconBlack}
          alt="Clear"
          style={{
            width: 13,
            height: 13,
            cursor: "pointer",
          }}
          onClick={handleClearSearch}
        />
      </Box>
     
    </Stack>
     {searchInputValue && (
      <Box
      marginLeft={type === "main" ? 4.2 : 5.3}
      marginRight={9}
        sx={{
          padding: "8px 16px",
          backgroundColor: "#f5f5f5",
          borderBottom: "1px solid #e0e0e0",
          fontSize: "14px",
          color: "#666",
        }}
      >
        {isSearching
          ? "Searching..."
          : filteredMessageList.length > 0
          ? `${filteredMessageList.length} result${
              filteredMessageList.length === 1 ? "" : "s"
            } found`
          : "No results found"}
      </Box>
    )}
    </Box>
  );
};

export default SearchInputFromGroupInfo;
